import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import { IconButton, Link, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { ORG_NOTIFICATION_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import NotificationForm from "./NotificationForm";

function NotificationDialog({
  editNotificationId = "",
  notificationName,
  variant = "button", // 'button' for add, 'link' for edit
  onSuccess,
}) {
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClickOpen = async () => {
    if (editNotificationId && editNotificationId !== "") {
      setLoading(true);
      try {
        const response = await AxiosInstance.get(
          ORG_NOTIFICATION_URL + editNotificationId
        );
        setEditData(response.data);
        setOpen(true);
      } catch (error) {
        console.error("Error fetching status:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setEditData(null);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditData(null);
  };

  const renderTrigger = () => {
    if (variant === "link" && editNotificationId) {
      return (
        <Link
          component="button"
          onClick={handleClickOpen}
          disabled={loading}
          sx={{
            cursor: "pointer",
            textDecoration: "none",
            color: "primary.main",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {notificationName}
        </Link>
      );
    }

    return (
      <Tooltip
        title="Add New Notification"
        onClick={handleClickOpen}
        disabled={loading}
      >
        <IconButton
          sx={{
            cursor: "pointer",
            margin: "2px",
            color: (theme) => theme.palette.grey[500],
            borderRadius: 2,
            border: 1,
            borderColor: "divider",
          }}
        >
          <AddTaskOutlinedIcon color="primary" />
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <>
      {renderTrigger()}
      <NotificationForm      
        open={open}
        onClose={handleClose}
        editData={editData}
        onSuccess={onSuccess}
        isEditMode={Boolean(editData)}
      />
    </>
  );
}
export default NotificationDialog;
